import angular from 'angular';
import uiRouter from 'angular-ui-router';
import auditprogramresultsComponent from './auditprogramresults.component';

let auditprogramresultsModule = angular.module('auditprogramresults', [
  uiRouter
])

.component('auditprogramresults', auditprogramresultsComponent);

export default auditprogramresultsModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramresults/auditprogramresults.js